import { createSlice } from '@reduxjs/toolkit';
import axios from 'utils/axios';
import { dispatch } from 'redux_data/store';

const slice = createSlice({
  name: 'app_settings', // This is the name of the slice
  initialState: {
    isFullWidth: false,
  },
  reducers: {
    setFullWidth(state, action) { // HAS ERROR
      state.isFullWidth = action.payload;
    },
  },
});

export const { 
    setFullWidth ,
} = slice.actions;

export default slice.reducer;
